import React from 'react';
import { Fieldset } from 'src/components/Forms/Fieldset';
import { RadioGroup } from 'src/core/forms';
import { Fields } from 'src/components/CustomisationPage/feature/customisation.types';
import { CustomRadio } from 'src/components/CustomisationPage/CustomRadio';
import { BackgroundStyles } from 'src/components/BundleProduct/MultipleStepCustomisation/customisations.types';
import classnames from 'classnames';

import classes from './TypeFieldSet.scss';

type TypeFieldsetProps = {
    isBundleView?: boolean;
    fieldPrefix?: string;
    fieldIndex?: number;
    backgroundStyles?: BackgroundStyles;
};
export const TypeFieldset: React.FC<TypeFieldsetProps> = ({
    fieldPrefix = '',
    isBundleView,
    fieldIndex,
    backgroundStyles,
}) => {
    return (
        <Fieldset disabled={false}>
            <div className={classnames({ [classes.wrapper]: !isBundleView })} style={backgroundStyles}>
                <RadioGroup field={`${fieldPrefix}${Fields.applicationType}`} initialValue="logo">
                    <CustomRadio
                        value="logo"
                        id={fieldIndex ? `${fieldIndex}logo` : 'logo'}
                        icon={isBundleView ? 'logo' : 'logo-new'}
                        title="Logo"
                        isBundleView={isBundleView}
                        isCustomInput={!isBundleView}
                    />
                    <CustomRadio
                        value="text"
                        id={fieldIndex ? `${fieldIndex}text` : 'text'}
                        icon={isBundleView ? 'text' : 'text-new'}
                        title="Text"
                        isBundleView={isBundleView}
                        isCustomInput={!isBundleView}
                    />{' '}
                </RadioGroup>
            </div>
        </Fieldset>
    );
};
